import React from 'react';
import BrandTable from './table.js';

class Brands extends React.Component{
	render(){
		return (
			<div>
				<BrandTable />
			</div>
		)
	}
}

export default Brands;




// WEBPACK FOOTER //
// ./src/components/brands/index.js